<template>
    <div>
        <van-sticky>
            <NavBar />
        </van-sticky>
        <div class="collectionList">
            <van-list
                v-model:loading="loading"
                :finished="finished"
                loading-text="Loading..."
                finished-text="No more"
                @load="onLoad">
                <div v-for="item in collectionData" :key="item.favorite_id || item.id || item.shop_supplier_id">
                    <div class="introduce" @click="handleShop(item)">
                        <img :src="getUrl(item.logo)" alt="">
                        <div class="comments">
                        <div>{{item.score}}</div>
                        <div>{{item.score_count}} reviews</div>
                        </div>
                    </div>
                    <div class="shopInfo" @click="handleShop(item)">
                        <div class="infoItem">
                        <div class="infoName">{{ item.store_name }}</div>
                        <div class="address">{{ item.address }}</div>
                        </div>
                        <div class="infoItem" style="text-align:center">
                            <img src="@/assets/shop/heart_red.png" alt=""  @click.stop="handleCollection(item.pid)" >
                        </div>
                    </div>
                </div>
        </van-list>
         <van-empty v-if="collectionData.length == 0" description="No data" />
        </div>
    </div>
</template>
<script>
import myMixin from '@/utils/myMixin'
import NavBar from '@/components/NavBar/index.vue'
import { Dialog,Toast  } from 'vant'
export default {
    name:'MyCollection',
    data(){
        return {
            loading:false,
            finished:false,
            collectionData:[
            ],
            queryForm:{
                type:10,
                page:1,
                list_rows:10,
            }
        }
    },
    mixins:[myMixin],
    components:{
        NavBar
    },
    methods:{
        onLoad(){
            this.$api.getFavoriteList(this.queryForm).then(res=>{
                if(res.code == 1){
                    const data = res.data.list.data
                    this.collectionData.push(...data)
                    // 如果当前返回的数据条数小于每页的条数，就说明下面没数据了
                    if( data.length < this.queryForm.list_rows ){
                        this.finished = true
                    }else{
                        // 当前页数加1
                        this.queryForm.page += 1
                        this.loading = false;
                    }
                }else{
                    Toast.fail(res.msg)
                }
            })
        },
        handleCollection(pid){
            Dialog.confirm({
                title: 'Remove Favorite',
                message: 'Are you sure you want to remove this favorite?',
            })
            .then(() => {
                this.$api.getShopFavorite({pid:pid,type:9}).then(res=>{
                    if(res.code == 1){
                        this.resetList()
                    }else{
                        Toast.fail(res.msg)
                    }
                })
            })
            .catch(() => {
            });
        },
        handleShop(item){
            const shopSupplierId = item.shop_supplier_id || item.pid
            if(!shopSupplierId){
                Toast.fail('Invalid store information')
                return
            }
            this.$router.push({
                path:'shop',
                query:{
                    shop_supplier_id:shopSupplierId,
                    app_id: item.app_id || ''
                }
            })
        },
        resetList(){
            this.collectionData.length = 0
            this.queryForm = {
                type:10,
                page:1,
                list_rows:10,
            }
            this.onLoad()
        }
    }
}
</script>
<style lang="scss" scoped>
    .collectionList{
        width: 100%;
        padding: 1rem;
        box-sizing: border-box;
    }
    .shopInfo{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0.5rem 0 1.5rem 0;
          .infoItem{
            .infoName{
              font-size: .875rem;
            }
            .address{
              color: #666666;
            }
            font-size: .75rem;
            img{
              width: 2.125rem;
              height: 2.125rem;
            }
          }
        }
    .introduce{
        width: 100%;
        height: 10rem;
        overflow: hidden;
        position: relative;
        img{
        width: 100%;
        }
        .comments{
        position: absolute;
        bottom: 1rem;
        right: 1rem;
        background: rgba(0, 0, 0, 0.20);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
        padding: .5rem;
        box-sizing: border-box;
        border-radius: .25rem;
        }
    }
</style>
